import React, {useMemo} from 'react';
import MetricsCardWithRank from '@/pages/dashboard/components/MetricsCardWithRank';
import TrendChart from './TrendChart';
import {useIntl} from 'umi';
import './index.scss';
import {
  SHOW_DIMENSION_ICON_MAP,
  SHOW_DIMENSION_PLATFORM_COLOR_KEYS,
  normalizeDimensionIconKey,
  isDimensionTrendIconIconfont,
  type IDimensionTrendIconUrlEntry,
} from '@dbl/core/chartEditor';

const DimNumberTrendCard = (props: any) => {
  const {
    className,
    height,
    lineData, 
    rankData,
    // headerRight,
    // filtersArr,
    // columnDimensions,
    metricData,
    metricKey,
    metricName,
    granularity,
    isSingle,
    isShowTrend,
    isShowDod,
    isShowStaticTime,
    metricInfo,
  } = props;
  const {formatMessage} = useIntl();

  const mapDoDName={
    dod: formatMessage({id: `dbl_common_dod_${granularity}`}),
    sdlw: formatMessage({id: `dbl_common_sdlw_${granularity}`}),
    change: formatMessage({id: 'dbl_common_change'})
  };

  const trendMapName={ today: formatMessage({id: `dbl_common_current_${granularity}`}), compare: formatMessage({id: `dbl_common_sdlw_${granularity}`})};

  const dodValues = Object.entries(metricData ?? {})
    ?.map(([key, dodItem]: [string, any]) => {
      if (isSingle ? key === 'change' : key !== 'change') {
        return null;
      }
      if (key === 'dod' || key === 'sdlw' || key === 'change') {
        const dataToUse = metricData?.[key] as any;
        return {
          titleEn: mapDoDName[key],
          titleCn: mapDoDName[key],
          extendFormatRule: dodItem?.extendFormatRule,
          thisTime: dataToUse?.this_time || '',
          lastTime: dataToUse?.last_time || '',
          value: dataToUse?.show_value || '',
          thisValue: dataToUse?.this_value || '',
          lastValue: dataToUse?.last_value || '',
          formatRule: 'absPercent1Decimal',
        };
      }
      return null; // 如果 key 不符合条件，返回 null
    })
    .filter(Boolean);

  const rankValues = rankData?.[0]?.series?.map((item:{data: string; percentage: string; name: string; icon: string;}, index: number) => {
    const {data, percentage, name, icon} = item || {};
    const iconCanon = icon ? normalizeDimensionIconKey(icon) : '';
    const meta =
      iconCanon && SHOW_DIMENSION_ICON_MAP[iconCanon]
        ? SHOW_DIMENSION_ICON_MAP[iconCanon]
        : SHOW_DIMENSION_ICON_MAP.default;
    const color =
      iconCanon && SHOW_DIMENSION_PLATFORM_COLOR_KEYS.includes(iconCanon)
        ? (SHOW_DIMENSION_ICON_MAP[iconCanon] as IDimensionTrendIconUrlEntry)
            .color
        : SHOW_DIMENSION_ICON_MAP.default.cololist?.[index];
    if (isDimensionTrendIconIconfont(meta)) {
      return {
        nameEn: name,
        value: data,
        subValue: percentage,
        iconSvgType: meta.iconfontType,
        disableIconSvgType: meta.disableIconfontType,
        color,
      };
    }
    const urlMeta = meta as IDimensionTrendIconUrlEntry;
    return {
      nameEn: name,
      value: data,
      subValue: percentage,
      icon: urlMeta.icon,
      disableIcon: urlMeta.disableIcon,
      color,
    };
  });

  const trendInfo = useMemo(() => {
    const {xAxis, series: [today, compare]} = lineData?.[0] || {xAxis: [], series: [[],[]]};
    const isPercent = today.valueType === "percent";
    const trendValues = xAxis?.map((item: any, index: number) => ({date: item, metrics: {[metricKey]: isPercent ? {last_value: +compare?.data?.[index]?.replace('%', '')/100, value: +today?.data?.[index]?.replace('%', '')/100} : {last_value: compare?.data?.[index], value: today?.data?.[index]}}}));
    return {
      trendValues,
      isPercent 
    };
  }, [lineData]);

  const formatConfig = {
    type: metricInfo?.unit || 'bmk',
    decimal: metricInfo?.accuracy || 0,
  };
  return (
    <MetricsCardWithRank
      formatRule={formatConfig}
      rankFormatRule={formatConfig}
      className={`dbl-dimension-number-trend-body ${className}`}
      value={metricData?.metricValue}
      dodStyle={isShowDod ? undefined : {display: 'none'}}
      dodData={dodValues}
      rankData={rankValues}
      subtitleEn={isShowStaticTime ? metricData?.staticTime : ''}
      metricsChart={
        isShowTrend ? <TrendChart
          height={height}
          titleEn={''}
          titleCn={''}
          isRightCard={false}
          isLeftCard={true}
          metricData={trendInfo.trendValues}
          loading={false}
          error={false}
          filterVal={{timeType: granularity.charAt(0).toUpperCase() + granularity.slice(1)}}
          showBubbleTitle={true}
          bubbleTitleEn={metricName}
          bubbleTitleCn={metricName}
          yAxisFormatRule={trendInfo.isPercent ? 'percent1Decimal' : "bmk0"}
          componentMetrics={[
            {
              metricKey,
              "formatRule": {
                type: trendInfo.isPercent ? 'percent' : (metricInfo?.unit || 'bmk'),
                decimal: metricInfo?.accuracy || 0,
              },
              "isCompare": true,
              "nameEn": trendMapName.today,
              "nameCn": trendMapName.today,
              "compareToolTipNameEn": trendMapName.compare,
              "compareToolTipNameCn": trendMapName.compare,
            }
          ]}
        /> : <></>
      }
    />
  );
};

export default DimNumberTrendCard;
